const TRANSLATIONS_STORAGE_KEY = 'translations-cache';

export { TRANSLATIONS_STORAGE_KEY };
